
import React from 'react';
import { Switch } from '@/components/ui/switch';
import { Label } from '@/components/ui/label';

interface NotesFilterProps {
  showNotes?: boolean;
  handleNotesChange: (checked: boolean) => void;
}

const NotesFilter: React.FC<NotesFilterProps> = ({
  showNotes,
  handleNotesChange,
}) => {
  return (
    <div>
      <div className="flex items-center space-x-2">
        <Switch
          id="notes"
          checked={showNotes}
          onCheckedChange={handleNotesChange}
          className="data-[state=checked]:bg-custom-primary dark:data-[state=checked]:bg-custom-secondaryLight"
        />
        <Label htmlFor="notes" className="font-sans text-custom-dark dark:text-gray-300">
          Afficher uniquement les vidéos avec des notes
        </Label>
      </div>
    </div>
  );
};

export default NotesFilter;
